import loader from '@/library/assets/svg/common/loader-blue.svg';
import styled from '@emotion/styled';
import { Size } from '@/library/types/files';

const iconSize: Partial<Record<Size, number>> = {
  lg: 18,
  sm: 12,
  xs: 10
};

const ProgressLoader = ({ size }: { size: Size }) => {
  return (
    <Container
      size={size}
      className="d-flex align-items-center justify-content-center bg-white rounded-circle"
    >
      <img alt="file-progress-loader" src={loader} width={iconSize[size]} height={iconSize[size]} />
    </Container>
  );
};

const Container = styled.div`
  width: ${({ size }: { size: Size }) => `${iconSize[size]}px`};
  height: ${({ size }: { size: Size }) => `${iconSize[size]}px`};
  position: absolute;
  right: ${({ size }: { size: Size }) => `-${(iconSize[size] || 0) / 2 - 2}px`};
  top: -2px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);

  > img {
    transform: scale(0.8);
  }
`;

export default ProgressLoader;
